<script setup lang="ts">

import { faFile, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { convertBytes } from '@shared/lib/convert-bytes'
import { TextQuaternary, TextTertiary } from '@shared/ui/typography'
import { BtnIcon } from '@shared/ui/button'
import { IconContainer } from '@shared/ui/icon'

defineOptions({
  name: 'FileItem',
})

withDefaults(defineProps<FileItemProps>(), {
  error: null,
})

const emit = defineEmits<{
  remove: []
}>()

interface FileItemProps {
  file: File
  error?: string | null
}

</script>

<template>
  <div :class="['file-item', { 'file-item--error': error }]">
    <div class="file-item__info">
      <div class="file-item__name">
        <IconContainer
          class="file-item__icon"
        >
          <FontAwesomeIcon
            :icon="faFile"
          />
        </IconContainer>
        <div class="file-item__detail">
          <TextTertiary>
            {{ file.name }}
          </TextTertiary>
          <TextQuaternary
            v-if="error"
            class="file-item__error"
          >
            {{ error }}
          </TextQuaternary>
        </div>
      </div>
      <TextQuaternary
        v-if="!error"
        class="file-item__size"
      >
        {{ convertBytes(file.size) }}
      </TextQuaternary>
    </div>
    <BtnIcon
      :icon="faXmark"
      color="gray"
      size="small"
      @click="emit('remove')"
    />
  </div>
</template>

<style scoped lang="scss" src="./FileItem.scss" />